import {
  PRODUCT_JUKE,
  PRODUCT_LIVE,
  PRODUCT_WEDDING_HALL,
  PRODUCT_REGISTRATION_ACTIVITY,
  PRODUCT_WATER_MIRROR,
  PRODUCT_INVITATION_CARD,
  PRODUCT_WECHAT_WEAPP,
  PRODUCT_COUPONS
} from '@constant'

/**
 * 加盟店平台营销
 */
export const PLATFORM_MARKETING = [
  // {
  //   bg: '#66A3FF',
  //   img: '//qnm.hunliji.com/o_1cspvle3e16bl19h1kc51cs11c0dh.png',
  //   title: '聚客宝',
  //   product_id: PRODUCT_JUKE
  // },
  {
    bg: '#FEA03C',
    img: '//qnm.hunliji.com/o_1cspvle3e18oo1i2o1e321olj109al.png',
    title: '直播',
    product_id: PRODUCT_LIVE
  },
  {
    bg: '#FFCD54',
    img: '//qnm.hunliji.com/o_1ctbuva8e1bgpbgr13k512ua1shp9.png',
    title: '优惠券',
    product_id: PRODUCT_COUPONS
  }
]

/**
 * 加盟店社交营销
 */
export const SOCIAL_MARKETING = [
  {
    bg: '#FF8CD0',
    img: '//qnm.hunliji.com/o_1cspvle3eki79fe19u611klss8g.png',
    title: '微传单+',
    product_id: PRODUCT_REGISTRATION_ACTIVITY
  },
  {
    bg: '#28D9C7',
    img: '//qnm.hunliji.com/o_1cspvle3emku1le21e4u1j8r1bg1k.png',
    title: '小程序',
    des: '即将推出',
    product_id: PRODUCT_WECHAT_WEAPP
  }
]

/**
 * 加盟店线下营销
 */
export const OFFLINE_MARKETING = [
  {
    bg: '#FFCD54',
    img: '//qnm.hunliji.com/o_1cspvle3e1cescosvbs1roa12dij.png',
    title: '水镜',
    product_id: PRODUCT_WATER_MIRROR
  },
  {
    bg: '#66A3FF',
    img: '//qnm.hunliji.com/o_1cspvle3drscurj2qcskcm30f.png',
    title: '婚礼现场',
    product_id: PRODUCT_WEDDING_HALL
  },
  {
    bg: '#FF8CD0',
    img: '//qnm.hunliji.com/o_1cspvle3ep9610ho19cpjefn65i.png',
    title: '商家端婚礼请帖',
    // des: '即将推出',
    product_id: PRODUCT_INVITATION_CARD
  }
]
